// src/app/components/emptyResult/EmptyResult.js
import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./EmptyResult.module.css";
import { Button, Icon } from "@zorni/components-lib";

/**
 * État vide de la page résultats (.empty-state) : message, suggestions de
 * destinations réellement proposées et bouton de réinitialisation.
 */
const EmptyResult = ({ suggestions = [], onSuggestion, onReset }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.empty_state}>
      <div className={styles.icon_wrap}>
        <Icon name="iconSearch" size="lg" color="inherit" />
      </div>

      <h2 className={styles.title}>{t("components.emptyResult.title", "Aucun voyage trouvé")}</h2>

      <p className={styles.message}>
        {t(
          "components.emptyResult.message",
          "Essayez d'ajuster vos filtres ou d'explorer d'autres dates et destinations."
        )}
      </p>

      {suggestions.length > 0 && onSuggestion && (
        <div className={styles.suggestions}>
          <p className={styles.suggestionsLabel}>
            {t("components.emptyResult.suggestions", "Destinations disponibles")}
          </p>
          <div className={styles.suggestionsList}>
            {suggestions.map((country) => (
              <Button
                key={country}
                variant="secondary"
                size="small"
                label={country}
                onClick={() => onSuggestion(country)}
              />
            ))}
          </div>
        </div>
      )}

      {onReset && (
        <Button
          variant="primary"
          label={t("components.emptyResult.reset", "Réinitialiser la recherche")}
          onClick={onReset}
        />
      )}
    </div>
  );
};

export default EmptyResult;
